var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6544 6.34401C15.7269 4.41648 12.5688 4.38166 10.6311 6.31939L9.12379 7.82666L10.0891 8.792L11.5964 7.28473C12.9908 5.89032 15.2845 5.90474 16.6891 7.30936C18.0937 8.71398 18.1081 11.0076 16.7137 12.402L15.2064 13.9093L16.1718 14.8746L17.679 13.3674C19.6168 11.4296 19.582 8.27154 17.6544 6.34401Z",
    fill: "#3E3E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28931 11.5918L8.79658 10.0846L7.83123 9.11922L6.32397 10.6265C4.38623 12.5642 4.42106 15.7223 6.34859 17.6498C8.27612 19.5774 11.4342 19.6122 13.372 17.6745L14.8792 16.1672L13.9139 15.2019L12.4066 16.7091C11.0122 18.1035 8.71855 18.0891 7.31393 16.6845C5.90931 15.2799 5.8949 12.9862 7.28931 11.5918Z",
    fill: "#3E3E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1303 9.865C13.7971 9.53179 13.2519 9.52687 12.9187 9.86008L9.86752 12.9112C9.53431 13.2445 9.53923 13.7896 9.87245 14.1229C10.2057 14.4561 10.7508 14.461 11.0841 14.1278L14.1352 11.0766C14.4684 10.7434 14.4635 10.1982 14.1303 9.865Z",
    fill: "#3E3E3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.66271003cd05e7719cb8b909e971c639.svg";
export { ForwardRef as ReactComponent };